import { render, staticRenderFns } from "./job-footer-buttons.vue?vue&type=template&id=cb04762c&scoped=true"
import script from "./job-footer-buttons.vue?vue&type=script&lang=js"
export * from "./job-footer-buttons.vue?vue&type=script&lang=js"
import style0 from "./job-footer-buttons.vue?vue&type=style&index=0&id=cb04762c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb04762c",
  null
  
)

export default component.exports